/**
 * pl-cart-quantity-input.js
 * ------------------------------------------------------------
 * Permite digitar a quantidade diretamente no carrinho (alem dos
 * botoes +/-). Ao confirmar (Enter ou blur), define a quantidade
 * exata via /cart/change.js e sincroniza a UI reaproveitando os
 * metodos publicos do proprio <cart-component> do tema.
 *
 * Descobertas validadas ao vivo (nao mexer sem re-testar):
 *   - Os botoes +/- leem a quantidade de data-quantity (atributo),
 *     NAO do texto exibido -> trocar o span por input e seguro.
 *   - cart-component.updateUI(cart) -> atualiza PIX / subtotal / totais
 *     (nao mexe no input de quantidade, seguro chamar sempre).
 *   - cart-component.renderCartItems(cart) redesenha a linha do item
 *     usando o TEMPLATE INTERNO DO BUNDLE, que sempre desenha um
 *     <span> no lugar do nosso <input> — isso troca o no do DOM e a
 *     segunda edicao para de funcionar (o elemento deixa de ser input).
 *     Por isso NAO chamamos renderCartItems no nosso proprio fluxo de
 *     digitacao: a quantidade exibida e o data-quantity sao atualizados
 *     manualmente, preservando o nosso <input> editavel.
 *   - PORÉM: o bundle guarda a quantidade numa variavel interna
 *     PROPRIA (memoria do componente), separada do atributo
 *     data-quantity do HTML. Quando o cliente digita um valor e
 *     atualizamos so o atributo, a TELA fica certa mas a MEMORIA do
 *     bundle fica desatualizada — ao clicar em +/- depois, o bundle
 *     usa a memoria dele (errada), causando divergencia visivel (ex:
 *     digitou 5, clicou em "-", o bundle calcula a partir do valor
 *     antigo e mostra um numero errado). Por isso este arquivo assume
 *     o controle TOTAL dos botoes +/- tambem (nao so do campo de
 *     texto): impedimos o clique de chegar no bundle (capture +
 *     stopPropagation) e processamos +/- nos mesmos, sempre a partir
 *     do data-quantity atual, nossa unica fonte de verdade.
 *   - O contador do header usa uma string localizada que NAO vem no
 *     JSON cru do /cart.js, entao ele e atualizado manualmente aqui.
 *   - O aviso de minimo, o botao de checkout e o aviso de cashback
 *     continuam sendo tratados pelo pl-cart-minimum-order.js (Section
 *     Rendering API), que reage a chamada /cart/change.js normalmente.
 *   - Fix de clique duplo: o componente pai (product-quantity)
 *     intercepta o clique antes dele chegar no nosso <input>, exigindo
 *     2 cliques para focar. Interceptamos na fase de CAPTURA (antes da
 *     fase de bolha onde o bundle escuta) e paramos a propagacao,
 *     deixando o navegador focar o input normalmente no 1o clique.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__plCartQuantityInputInit) return;
  window.__plCartQuantityInputInit = true;

  var INPUT_SELECTOR = '.product-quantity__input';
  var busyKeys = {}; // evita chamadas concorrentes para a mesma variante

  function isQtyInput(el) {
    return el && el.matches && el.matches(INPUT_SELECTOR);
  }

  function getCartComponent() {
    return document.querySelector('cart-component');
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var els = document.querySelectorAll('.header__icon--cart-count, .header__icon--cart-bullet');
    els.forEach(function (el) {
      if (/\d+/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d+/, cart.item_count);
      } else {
        el.textContent = cart.item_count;
      }
    });
  }

  function setInputValue(inputEl, value) {
    if (inputEl.tagName === 'INPUT') {
      inputEl.value = value;
    } else {
      inputEl.textContent = value;
    }
  }

  function getInputValue(inputEl) {
    var raw = inputEl.tagName === 'INPUT' ? inputEl.value : inputEl.textContent;
    return parseInt(String(raw).replace(/\D/g, ''), 10);
  }

  function commitQuantityValue(quantityEl, inputEl, currentQty, newQty) {
    var key = quantityEl.getAttribute('data-key');

    if (isNaN(newQty) || newQty < 0) {
      if (inputEl) setInputValue(inputEl, currentQty);
      return;
    }

    if (newQty === currentQty) {
      if (inputEl) setInputValue(inputEl, currentQty);
      return;
    }

    if (busyKeys[key]) return;
    busyKeys[key] = true;

    if (inputEl) inputEl.setAttribute('disabled', 'disabled');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change.js ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var comp = getCartComponent();
        if (comp && typeof comp.updateUI === 'function') {
          try { comp.updateUI(cart); } catch (e) {}
        }
        // NAO chamar comp.renderCartItems(cart) aqui (ver nota no topo).
        quantityEl.setAttribute('data-quantity', newQty);
        if (inputEl) setInputValue(inputEl, newQty);
        updateHeaderCount(cart);
      })
      .catch(function (err) {
        console.warn('[pl-cart-quantity-input] Falha ao atualizar quantidade:', err);
        if (inputEl) setInputValue(inputEl, currentQty);
      })
      .finally(function () {
        busyKeys[key] = false;
        if (inputEl) inputEl.removeAttribute('disabled');
      });
  }

  function commitQuantity(inputEl) {
    var quantityEl = inputEl.closest('product-quantity');
    if (!quantityEl) return;
    var currentQty = parseInt(quantityEl.getAttribute('data-quantity'), 10);
    var newQty = getInputValue(inputEl);
    commitQuantityValue(quantityEl, inputEl, currentQty, newQty);
  }

  // ------------------------------------------------------------
  // Assume o controle TOTAL dos botoes +/-, impedindo que o clique
  // chegue no listener proprio do bundle. Motivo: o bundle guarda a
  // quantidade numa variavel interna PROPRIA (na memoria do
  // componente), separada do atributo data-quantity do HTML. Quando
  // o cliente digita um valor e nos atualizamos so o atributo, a TELA
  // fica certa mas a MEMORIA do bundle continua com o valor antigo —
  // ao clicar em +/-, o bundle usa a memoria dele (errada), causando
  // divergencia (ex: digitou 5, clicou em "-", bundle calcula a partir
  // do 15 antigo e mostra 14). Processando +/- nos mesmos, sempre a
  // partir do data-quantity atual (nossa unica fonte de verdade,
  // sempre confirmada pela resposta real da API), essa divergencia
  // deixa de ser possivel.
  // ------------------------------------------------------------
  function isQtyButton(el) {
    return el && el.closest && el.closest('.product-quantity__button');
  }

  document.addEventListener('mousedown', function (e) {
    if (isQtyButton(e.target)) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-quantity__button');
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    var quantityEl = btn.closest('product-quantity');
    if (!quantityEl) return;

    var isIncrement = btn.classList.contains('product-quantity__button--increment');
    var currentQty = parseInt(quantityEl.getAttribute('data-quantity'), 10) || 0;
    var newQty = isIncrement ? currentQty + 1 : Math.max(0, currentQty - 1);

    var inputEl = quantityEl.querySelector(INPUT_SELECTOR);
    if (inputEl) setInputValue(inputEl, newQty); // feedback visual imediato

    commitQuantityValue(quantityEl, inputEl, currentQty, newQty);
  }, true);

  // ------------------------------------------------------------
  // Fix de clique duplo: intercepta na fase de captura para que o
  // navegador foque o input ja no primeiro clique.
  // ------------------------------------------------------------
  document.addEventListener('mousedown', function (e) {
    if (isQtyInput(e.target)) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    if (isQtyInput(e.target)) e.stopPropagation();
  }, true);

  // ------------------------------------------------------------
  // Digitar + confirmar (Enter ou blur)
  // ------------------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (!isQtyInput(e.target)) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  });

  document.addEventListener('blur', function (e) {
    if (!isQtyInput(e.target)) return;
    commitQuantity(e.target);
  }, true);

  document.addEventListener('focus', function (e) {
    if (!isQtyInput(e.target)) return;
    if (e.target.tagName === 'INPUT') {
      setTimeout(function () { e.target.select(); }, 0);
    }
  }, true);

  // ------------------------------------------------------------
  // "Curador": o bundle (via seus proprios botoes +/-, fora do nosso
  // controle) as vezes reverte nosso <input> de volta para <span>.
  // Este observer fica de olho em toda a area do carrinho e recria o
  // <input> sempre que isso acontecer, preservando o valor atual.
  // Usa debounce curto para nao rodar a cada micro-mutacao do DOM.
  // ------------------------------------------------------------
  var healScheduled = false;

  function healQuantityInputs() {
    healScheduled = false;
    document.querySelectorAll('product-quantity').forEach(function (qtyEl) {
      var current = qtyEl.querySelector(INPUT_SELECTOR);
      if (!current || current.tagName === 'INPUT') return; // ja e input, nada a fazer

      var value = current.textContent.trim();
      var input = document.createElement('input');
      input.type = 'number';
      input.setAttribute('inputmode', 'numeric');
      input.min = '0';
      input.value = value;
      input.className = 'product-quantity__input';
      input.setAttribute('aria-label', 'Quantidade');
      current.replaceWith(input);
    });
  }

  function scheduleHeal() {
    if (healScheduled) return;
    healScheduled = true;
    requestAnimationFrame(healQuantityInputs);
  }

  function initHealObserver() {
    // Prefere observar so a area do carrinho (mais leve). Cai para
    // document.body como fallback se o componente ainda nao existir
    // no momento do load.
    var scopeEl = document.querySelector('cart-component') || document.body;

    var observer = new MutationObserver(function () {
      // Sem filtro fino aqui: quando o bundle redesenha um item do
      // carrinho, ele costuma substituir o <cart-item> INTEIRO (nao so
      // o campo de quantidade), entao a mutacao aparece no CONTAINER
      // pai da lista, nao dentro do product-quantity em si — um filtro
      // que procurasse ancestral (.closest) nunca bateria. Mais simples
      // e robusto: agenda a cura em qualquer mutacao no escopo; a
      // funcao em si e barata (retorna cedo se ja for <input>).
      scheduleHeal();
    });

    observer.observe(scopeEl, { childList: true, subtree: true });

    // roda uma vez no load tambem, caso a pagina ja carregue com spans
    scheduleHeal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHealObserver);
  } else {
    initHealObserver();
  }
})();